import React from 'react';
import PropTypes from 'prop-types';

import { SummaryDetail, SummaryCategory, SummaryGroupWrapper } from './css';

const FormSummaryRow = ({ label, value }) =>
  (!!value || typeof value === 'number') && (
    <SummaryGroupWrapper>
      <SummaryCategory>
        <span className="frg-body-font-14px">{label}</span>
      </SummaryCategory>
      <SummaryDetail>
        <span className="frg-body-font-14px">{value}</span>
      </SummaryDetail>
      <div className="clear" />
    </SummaryGroupWrapper>
  );

FormSummaryRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

FormSummaryRow.defaultProps = {
  value: ''
};

export default FormSummaryRow;
